import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VContainer,
        [
          _c("p", [
            _vm._v(_vm._s(_vm.$t("attributes.label.register_group_text"))),
          ]),
          _c(
            VForm,
            {
              ref: "form",
              staticClass: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                VRow,
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12", md: "12" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          rules: _vm.rules.name,
                          label: _vm.label.group_name,
                          placeholder: _vm.label.group_name,
                          name: "form.group_name",
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.form.group_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "group_name", $$v)
                          },
                          expression: "form.group_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(VTextarea, {
                        attrs: {
                          rules: _vm.rules.description,
                          outlined: "",
                          name: "form.group_description",
                          label: _vm.label.group_description,
                          placeholder: _vm.label.group_description,
                          rows: "2",
                          dense: "",
                        },
                        model: {
                          value: _vm.form.group_description,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "group_description", $$v)
                          },
                          expression: "form.group_description",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "text-right", attrs: { cols: "12" } },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass: "ml-md-1 mb-2 btn-block-xs-only",
                          attrs: { type: "button", color: "primary" },
                          on: { click: _vm.registerGroup },
                        },
                        [
                          _c(VIcon, { attrs: { left: "" } }, [
                            _vm._v("icon-check"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("attributes.button.register")) +
                              " "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }